const dateTimeFormats = {
    "zh-TW": {
        date: {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        },
        dateTime: {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        },
    },
};

export default dateTimeFormats;
